import { GuideSection } from '@/components/guides/GuideSection';
import { GuideCallout } from '@/components/guides/GuideCallout';

const TIPS = [
  {
    title: "Glance, don't read",
    body: 'The coaching pane is a reminder, not a script. If you read it word-for-word your delivery flattens. Let your eyes catch a phrase, then look back up and talk.',
  },
  {
    title: 'Buy time naturally',
    body: '"Let me think about that for a second" or "Good question — let me walk through the approach" gives NeuraX two or three seconds to surface a prompt. Use those filler phrases deliberately.',
  },
  {
    title: 'Ask NeuraX for help directly',
    body: 'If you\'re stuck, you can type a short question in the chat field (e.g., "time complexity of merge sort") and get an answer in a second. The interviewer doesn\'t see you type.',
  },
  {
    title: "Don't fight the prompt",
    body: 'If NeuraX suggests one approach and you already know a better one, go with yours. The coach is a teammate, not a boss.',
  },
];

export function DuringInterviewSection() {
  return (
    <GuideSection
      id="during-interview"
      eyebrow="Step 4"
      title="During the interview"
      description="How to actually use NeuraX without letting it get in the way. A few habits go a long way."
    >
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {TIPS.map((tip) => (
          <div key={tip.title} className="glass-card p-4">
            <p className="text-sm font-semibold text-white">{tip.title}</p>
            <p className="mt-1 text-xs text-muted-foreground">{tip.body}</p>
          </div>
        ))}
      </div>

      <GuideCallout variant="info" title="What the coaching feed looks like">
        <p>
          The left side of the NeuraX window streams what the interviewer is saying — a rolling
          transcript. The right side is the coaching pane, which updates in real time with
          structure, suggested answers, formulas, code snippets, or clarifying questions. Think of
          it as a live teammate whispering in your ear.
        </p>
      </GuideCallout>

      <GuideCallout variant="tip" title="Positioning matters">
        <p>
          The best setup: laptop camera at eye level, NeuraX window just below the camera. Your eyes
          drift slightly downward when you check it, which looks like normal note-taking on camera.
          If you turn your head or look far away, it reads as distraction.
        </p>
      </GuideCallout>

      <GuideCallout variant="warning" title="Privacy: what your team sees, what they don't">
        <p>
          Your team (recruiters, admins) can see the <strong>transcript</strong> of your interview
          and the <strong>coaching threads</strong> NeuraX surfaced. They <strong>cannot</strong>{' '}
          see your screen, your webcam, your typing, or anything outside NeuraX. The transcript is
          for your team to give you better feedback after the round.
        </p>
      </GuideCallout>
    </GuideSection>
  );
}
